var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradiente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1 746.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1 0 0 -1 1 746.27)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: #e10a17;      }    ")), /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 3.05 0 0 1 0 1 3.05 0 3.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 42.05,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 81.61,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 118.81,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 153.81,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 186.73,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 217.7,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 249.87 0 246.83 1 246.82 1 249.87 0 249.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 274.22,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 300,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 324.24,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 347.04,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 368.5,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 388.68,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 407.67,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 428.59 0 425.54 1 425.54 1 428.58 0 428.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 442.36,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 458.19,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 473.09,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 487.13,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 500.35,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 512.81,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 524.56,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 535.64,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 546.1,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 555.97,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 565.31,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 574.14,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 582.5,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 590.42,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 597.94,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 605.08,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 611.88,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 618.36,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 624.53,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 630.44,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 636.09,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 641.5,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 646.71,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 651.72,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 656.56,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 661.23,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 665.77,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 670.17,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 674.46,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 678.64,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 682.73,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 686.75,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 690.69,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 694.58,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 698.42,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 702.21,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 705.98,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 712.76 0 709.72 1 709.71 1 712.76 0 712.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 713.44,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 717.15,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 720.85,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 724.55,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 728.26,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 731.98,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 735.71,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 739.46,
    width: 1,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 743.23,
    width: 1,
    height: 3.05
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradiente);
export default __webpack_public_path__ + "static/media/Gradiente.10c2c78df90f6d2f90fc31fdb6778971.svg";
export { ForwardRef as ReactComponent };